<ion-list class="sm-total-summary">
	<ion-item lines="none" [ngClass]="{'sm-error': sale.subTotal < 0}">Subtotal: <div slot="end">{{ sale.subTotal | salonMonsterCurrency }}</div></ion-item>
	<ion-item lines="none" [ngClass]="{'sm-error': sale.taxesTotal < 0}">Taxes: <div slot="end">{{ sale.taxesTotal | salonMonsterCurrency }}</div></ion-item>
	<ion-item lines="none" [ngClass]="{'sm-error': sale.total < 0}"><b class="sm-sale-total">Total:</b><div class="sm-sale-total" slot="end"> {{ sale.total | salonMonsterCurrency }}</div></ion-item>
</ion-list>
